import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  IMAGES_PROGRESS,
  IMAGES_SUCCESS,
  IMAGES_FAILED,
  IMAGES_GET_LIST_PROGRESS,
  IMAGES_GET_LIST_SUCCESS,
  IMAGES_GET_LIST_FAILED,
  IMAGES_FORM_SUBMIT_PROGRESS,
  IMAGES_FORM_SUBMIT_SUCCESS,
  IMAGES_FORM_SUBMIT_FAILED,
  IMAGES_GET_MATERIAL_PROGRESS,
  IMAGES_GET_MATERIAL_SUCCESS,
  IMAGES_GET_MATERIAL_FAILED,
  IMAGES_CLEAR_STATE,
  IMAGES_CLEAR_FLASH_MESSAGE,
} from '../actions/imagesAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case IMAGES_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: IMAGES_PROGRESS },
      });
    }
    case IMAGES_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: IMAGES_SUCCESS },
      });
    }
    case IMAGES_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: IMAGES_FAILED },
      });
    }
    case IMAGES_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: IMAGES_PROGRESS } });
    }
    case IMAGES_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: IMAGES_SUCCESS },
      });
    }
    case IMAGES_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: IMAGES_FAILED } });
    }
    case IMAGES_GET_MATERIAL_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: IMAGES_PROGRESS },
      });
    }
    case IMAGES_GET_MATERIAL_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.image },
        loadActiveStatus: { $set: IMAGES_SUCCESS },
      });
    }
    case IMAGES_GET_MATERIAL_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: IMAGES_FAILED },
      });
    }
    case IMAGES_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case IMAGES_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
